import { Link } from 'gatsby';
import React from 'react';
import AngleLeft from '../icons/AngleLeft';

interface BackButtonProps {
  label: string;
  url: string;
}

const BackButton: React.FC<BackButtonProps> = ({ label, url }) => (
  <Link
    className="inline-flex items-center px-1 py-2 text-sm font-medium transition rounded-sm text-primary hover:text-slate-700 u-ring"
    to={url}
  >
    <AngleLeft className="w-auto h-4 mr-3" /> {label}
  </Link>
);

export default BackButton;
